import { useRef } from "react";
import { motion } from "framer-motion";

export const Magnetic = ({ children, strength = 0.25 }) => {
  const ref = useRef(null);

  const handleMouse = (e) => {
    if (window.matchMedia("(pointer: coarse), (prefers-reduced-motion: reduce)").matches) return;
    const el = ref.current;
    if (!el) return;
    const { left, top, width, height } = el.getBoundingClientRect();
    el.style.transform = `translate(${(e.clientX - (left + width / 2)) * strength}px, ${(e.clientY - (top + height / 2)) * strength}px)`;
  };

  const reset = () => {
    if (ref.current) ref.current.style.transform = "translate(0px, 0px)";
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMouse}
      onMouseLeave={reset}
      className="inline-block max-w-full transition-transform duration-300 ease-out"
    >
      {children}
    </motion.div>
  );
};
